import { createFileRoute } from "@tanstack/react-router";
import ResourcesIndex from "@/pages/site/ResourcesIndex";

export const Route = createFileRoute("/resources/")({
  component: () => <ResourcesIndex />,
});
